<template>
  <div class="bg-white rounded-sm mx-2 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <InsolvencyPractitionersRegistry/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InsolvencyPractitionersRegistry
  from "@/domains/home/services/registry/practitioners/InsolvencyPractitionersRegistry.vue";
</script>
